import { useEffect } from "react";
import { getAudioContext, playChime } from "@/lib/sound";

export function useIntroChime() {
  useEffect(() => {
    if (localStorage.getItem("cs-sound") === "off") return;
    let alive = true;

    const cleanup = () => {
      window.removeEventListener("pointerdown", attempt);
      window.removeEventListener("keydown", attempt);
    };

    const attempt = () => {
      const ac = getAudioContext();
      if (!ac) return;
      if (ac.state === "running") {
        if (playChime()) cleanup();
        return;
      }
      ac.resume()
        .then(() => {
          if (alive && ac.state === "running" && playChime()) cleanup();
        })
        .catch(() => {});
    };

    const t = setTimeout(attempt, 450);
    window.addEventListener("pointerdown", attempt);
    window.addEventListener("keydown", attempt);
    return () => {
      alive = false;
      clearTimeout(t);
      cleanup();
    };
  }, []);
}
